import { Routes } from '@angular/router';
import { ResetMyPasswordComponent } from './reset-my-password/reset-my-password.component';

export const PasswordRouter: Routes = [
  {
    path: 'ResetMyPassword',
    component: ResetMyPasswordComponent,
    data: { title: 'Reset My Password', breadcrumb: 'Reset Password' }
  }
];
